/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-07-12 11:51:03
 * @LastEditors: linxi
 * @LastEditTime: 2021-07-12 11:56:50
 */
import { Radio } from "antd";
import React from "react";
import { StackedLine } from "../../components/StackedLine";

export interface AnaylseContentProps {
  title:string;
  time: number;
  setTime: (val: number) => void;
  legendList: any;
  seriesList: any;
}

export const DataAnaylseContent: React.FC<AnaylseContentProps> = ({
  title,
  time,
  setTime,
  legendList,
  seriesList,
}) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignContent: "center",
        }}
      >
        <h3>{title}</h3>
        <Radio.Group
          defaultValue={time}
          value={time}
          onChange={(e: any) => {
            setTime(e.target.value);
          }}
          optionType="button"
          buttonStyle="solid"
        >
          <Radio.Button value={0}>近七天</Radio.Button>
          <Radio.Button value={1}>近30天</Radio.Button>
          <Radio.Button value={2}>近一年</Radio.Button>
        </Radio.Group>
      </div>
      <div style={{ flex: 1 }}>
        <StackedLine
          // timeQuantum={keyThree}
          timeQuantum={time}
          legendData={legendList}
          seriesData={seriesList}
          style={{ height: "100%" }}
        />
      </div>
    </>
  );
};
